
import { toast as sonnerToast } from "sonner";

// Create a wrapper for the toast function with custom defaults
const toast = {
  ...sonnerToast,
  success: (message: string, options?: any) => 
    sonnerToast.success(message, { duration: 4000, ...options }),
  error: (message: string, options?: any) => 
    sonnerToast.error(message, { duration: 5000, ...options }),
  warn: (message: string, options?: any) => 
    sonnerToast.warning(message, { duration: 5000, ...options }),
  info: (message: string, options?: any) => 
    sonnerToast.info(message, { duration: 4000, ...options }),
};

export { toast };
